"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetScopedAtom = exports.useScopedAtomValue = exports.useScopedAtom = void 0;
const jotai_1 = require("jotai");
const react_1 = require("react");
const index_1 = require("./index");
class ScopedStoreNotFoundError extends Error {
    constructor() {
        super('No scoped store found');
    }
}
exports.useScopedAtom = ((atom, options) => {
    const scopedProviderContext = (0, react_1.useContext)(index_1.ScopedProviderContext);
    const scopedStore = scopedProviderContext.get(atom);
    if (!scopedStore) {
        throw new ScopedStoreNotFoundError();
    }
    return (0, jotai_1.useAtom)(atom, { store: scopedStore, ...options });
});
const useScopedAtomValue = (atom, options) => {
    const scopedProviderContext = (0, react_1.useContext)(index_1.ScopedProviderContext);
    const scopedStore = scopedProviderContext.get(atom);
    if (!scopedStore) {
        throw new ScopedStoreNotFoundError();
    }
    return (0, jotai_1.useAtomValue)(atom, { store: scopedStore, ...options });
};
exports.useScopedAtomValue = useScopedAtomValue;
const useSetScopedAtom = (atom, options) => {
    const scopedProviderContext = (0, react_1.useContext)(index_1.ScopedProviderContext);
    const scopedStore = scopedProviderContext.get(atom);
    if (!scopedStore) {
        throw new ScopedStoreNotFoundError();
    }
    return (0, jotai_1.useSetAtom)(atom, { store: scopedStore, ...options });
};
exports.useSetScopedAtom = useSetScopedAtom;
